// 마을 NPC 강조 창구: UI(src/ui)가 가까운 NPC 인덱스(GameView.village.nearNpc)를 적어 두면 NPC 렌더(npcs.ts)가 읽는다.
// render/index.ts가 view.village를 직접 넘겨 줄 수 있게 되면 이 모듈은 필요 없다(공유 파일 요청 참고).
let near = -1;
export function setNearNpc(i: number): void { near = i; }
export function getNearNpc(): number { return near; }
